import React, { useEffect, useMemo, useState, forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import { FormGroup } from 'react-bootstrap';
import { cloneDeep, get, uniqBy } from 'lodash';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AlignmentConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/AlignmentConfig';
import { BoldConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/BoldConfig';
import { ColorConfig } from '../../../Pages/Library/DPP/Library/ControlConfig/ColorConfig';
import { customStyles, setImage } from '../../helper';
import noImage from '../../../assets/images/no-image.png';
import * as action from '../../../Pages/Library/UserInstructionLibrary/store/UserInstruction.action';
import * as careAction from '../../../Pages/DevlopmentOrder/CareLabels/store/CARELABEL.action.js';

const customStylesNew = {
  ...customStyles,
  control: () => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    // height: "100%",
    height: '30px',
    borderBottom: '1px solid #6a6a6a',
  }),
};
export const CareUserInstructionSetting = forwardRef(({ obj, handleChangeByPath, handleImageUpload, isFromProduct }, ref) => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { devOrderId } = useParams();

  useEffect(() => {
    dispatch(action.fetchUserInstructionAction(null, t));
  }, [dispatch]);

  const [error, setError] = useState({});

  const { UserInstructionDetails } = useSelector((state) => state);
  const { userInstructionList } = UserInstructionDetails;

  const addobj = (path) => {
    const cloneObj = cloneDeep({ ...obj });
    const getArr = get(cloneObj, path, []);
    if (path === 'careLabelsArr') {
      getArr.push({ careLabel: null, fieldName: null });
    } else {
      getArr.push({ image: '', title: '', description: '' });
    }
    handleChangeByPath(getArr, path);
  };
  const removeObj = (i, path) => {
    const cloneObj = cloneDeep({ ...obj });
    const getArr = get(cloneObj, path, []);
    getArr.splice(i, 1);
    handleChangeByPath(getArr, path);
  };

  const careLabelOptions = useMemo(() => {
    if (userInstructionList?.length) {
      return uniqBy(
        userInstructionList?.filter((vl) => !vl.forDocument),
        '_id',
      );
    }
    return [];
  }, [userInstructionList]);

  const callTabsColumnsAPi = async (ind, tabId) => {
    const columnData = await dispatch(action.fetchColumnDetailList(tabId));
    if (columnData?.length) {
      const columns = columnData?.filter((vl) => ['Textbox', 'Image'].includes(vl?.columnDetails?.columnType?.key));
      handleChangeByPath(columns, `careLabelsArr[${ind}].fieldOptions`);
    }
  };

  const callFieldBasedColumnsValueApi = async (ind, columnId, tabId, columnDetails) => {
    const columnWiseValues = await dispatch(action.getAllUserTabs(tabId));
    if (isFromProduct && devOrderId) {
      const paramsData = {
        devOrderId,
      };
      const productCareLabels = await dispatch(careAction.fetchCareLabelForProductDpp(paramsData));
      if (columnWiseValues?.length && productCareLabels?.length) {
        const getTabDatas = productCareLabels?.find((vl) => vl.tabId === tabId)?.tabDetails;
        let volValues = getTabDatas?.filter((vl) => vl?.columnId === columnId);
        const checkVolValAreImage = volValues?.find(
          (vl) => vl?.value && typeof vl?.value === 'object' && ('image' in (vl?.value || {}) || 'fullImage' in (vl?.value || {})),
        );
        if (checkVolValAreImage || columnDetails?.columnDetails?.columnType?.key === 'Image') {
          volValues = volValues?.filter((vl) => vl?.value && (vl?.value?.image || vl?.value?.fullImage));
        }
        handleChangeByPath(volValues, `careLabelsArr[${ind}].columnValues`);
      }
    } else if (columnWiseValues?.length) {
      let volValues = columnWiseValues?.filter((vl) => vl?.columnId === columnId);

      const checkVolValAreImage = volValues?.find((vl) => typeof vl.value === 'object' && ('image' in (vl?.value || {}) || 'fullImage' in (vl?.value || {})));
      if (checkVolValAreImage) {
        volValues = volValues?.filter((vl) => vl?.value?.image || vl?.value?.image);
      }
      handleChangeByPath(volValues, `careLabelsArr[${ind}].columnValues`);
    }
  };

  const validateCareLabel = () => {
    const errMsg = 'This field is required';
    const cloneState = cloneDeep(obj);
    const errors = {};
    let hasError = false;
    cloneState?.careLabelsArr?.forEach((err, i) => {
      if (!err?.careLabel) {
        if (!errors[i]) {
          errors[i] = {};
        }
        hasError = true;
        errors[i].careLabel = errMsg;
      }
      if (!err?.fieldName) {
        if (!errors[i]) {
          errors[i] = {};
        }
        hasError = true;
        errors[i].fieldName = errMsg;
      }
    });
    setError(errors);
    return hasError;
  };

  useImperativeHandle(ref, () => ({
    validateCareLabel: () => validateCareLabel(), // Expose a method to reset local state
  }));

  const getImageSrc = (image) => {
    if (image?.includes('care_user_instruction')) {
      return setImage(image);
    }
    return image || noImage;
  };
  return (
    <>
      <FormGroup className="mb-0">
        <div className="common-input-control mb-0">
          <p className="f-16 text-bold field-name">{t('DPP.CONTROL.CARE_USER_LABEL.ENTER_SUB_HEADING')}</p>
          <input
            type="text"
            className="form-control"
            value={obj?.subHeading}
            placeholder={t('DPP.CONTROL.CARE_USER_LABEL.ENTER_SUBHEADER_TITLE')}
            onChange={(e) => handleChangeByPath(e.target.value, 'subHeading')}
            maxLength="40"
          />
        </div>
      </FormGroup>
      <div className="d-flex">
        <AlignmentConfig
          obj={obj}
          handleAlignment={(e) => handleChangeByPath(e.target.value, 'otherConfiguration.subHeadAlignment')}
          dataName="subHeadAlignment"
        />
        <ColorConfig obj={obj} handleColor={(e) => handleChangeByPath(e.target.value, 'otherConfiguration.subHeadColour')} dataName="subHeadColour" />
        <BoldConfig obj={obj} handleBold={(e) => handleChangeByPath(e.target.checked, 'otherConfiguration.subHeadBold')} dataName="subHeadBold" />
      </div>
      {obj?.careLabelsArr?.map((vl, ind) => {
        return (
          <div key={vl} className="form-row position-relative">
            <div className="col-md-6">
              <div className="common-react-select mb-0">
                <p className="field-name">
                  {t('DPP.CONTROL.CARE_USER_LABEL.CARE_USER_LABEL')} <span className="p-0">*</span>
                </p>
                <Select
                  placeholder={t('DPP.CONTROL.CARE_USER_LABEL.SELECT_CARE_USER_LABEL')}
                  options={careLabelOptions}
                  styles={customStylesNew}
                  className="common-select"
                  classNamePrefix="common-select"
                  getOptionLabel={(option) => option?.name}
                  getOptionValue={(option) => option?._id}
                  value={careLabelOptions?.find((ele) => ele?._id === vl?.careLabel?._id) || null}
                  onChange={(selected) => {
                    handleChangeByPath(selected, `careLabelsArr[${ind}].careLabel`);
                    callTabsColumnsAPi(ind, selected._id);
                  }}
                />
                <span className="error-message">{error?.[ind]?.careLabel}</span>
              </div>
            </div>
            <div className="col-md-6">
              <div className="d-flex">
                <div className="common-react-select flex-fill mb-0">
                  <p className="field-name">
                    {t('DPP.CONTROL.CARE_USER_LABEL.FIELD_NAME')} <span className="p-0">*</span>
                  </p>
                  <Select
                    placeholder={t('DPP.CONTROL.CARE_USER_LABEL.SELECT_FIELD_NAME')}
                    options={vl?.fieldOptions || []}
                    styles={customStylesNew}
                    getOptionLabel={(option) => option?.name}
                    getOptionValue={(option) => option?._id}
                    className="common-select"
                    classNamePrefix="common-select"
                    value={vl?.fieldOptions?.find((ele) => ele?._id === vl?.fieldName?._id) || null}
                    onChange={(selected) => {
                      handleChangeByPath(selected, `careLabelsArr[${ind}].fieldName`);
                      callFieldBasedColumnsValueApi(ind, selected._id, selected?.tabId, selected);
                    }}
                  />
                  <span className="error-message">{error?.[ind]?.fieldName}</span>
                </div>
                <div className="btns-container">
                  {obj?.careLabelsArr?.length - 1 === ind ? (
                    <>
                      <button type="button" aria-label="Upload" className="btn btn-outline sm" onClick={() => addobj('careLabelsArr')}>
                        <i className="icon-Add-bold" />
                      </button>
                      {obj?.careLabelsArr?.length > 1 && (
                        <button
                          type="button"
                          aria-label="Upload"
                          className="btn btn-outline sm mt-1"
                          onClick={() => (obj?.careLabelsArr?.length > 1 ? removeObj(ind, 'careLabelsArr') : {})}
                        >
                          <i className="icon-Delete-bold" />
                        </button>
                      )}
                    </>
                  ) : (
                    <button
                      type="button"
                      aria-label="Upload"
                      className="btn btn-outline sm"
                      onClick={() => (obj?.careLabelsArr?.length > 1 ? removeObj(ind, 'careLabelsArr') : {})}
                    >
                      <i className="icon-Delete-bold" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <div className="d-flex">
        <AlignmentConfig obj={obj} handleAlignment={(e) => handleChangeByPath(e.target.value, 'otherConfiguration.careAlignment')} dataName="careAlignment" />
        <ColorConfig obj={obj} handleColor={(e) => handleChangeByPath(e.target.value, 'otherConfiguration.careColour')} dataName="careColour" />
        <BoldConfig obj={obj} handleBold={(e) => handleChangeByPath(e.target.checked, 'otherConfiguration.careBold')} dataName="careBold" />
      </div>
      <div className="d-flex">
        <p className="mb-0">Add more information ? </p>&nbsp;&nbsp;
        <FormGroup className="mb-0">
          <div className="d-flex align-items-center">
            <p className="custom-radio mb-0">
              <input
                type="radio"
                id="yesOption"
                value="yes"
                onChange={(e) => handleChangeByPath(e.target.value, 'addMoreInfo')}
                name="option"
                checked={obj?.addMoreInfo === 'yes'}
              />
              <label htmlFor="yesOption">{t('DPP.CONTROL.CARE_USER_LABEL.YES')}</label>
            </p>
            <p className="custom-radio mb-0 ml-4">
              <input
                type="radio"
                id="noOption"
                value="no"
                onChange={(e) => handleChangeByPath(e.target.value, 'addMoreInfo')}
                name="option"
                checked={obj?.addMoreInfo === 'no'}
              />
              <label htmlFor="noOption">{t('DPP.CONTROL.CARE_USER_LABEL.NO')}</label>
            </p>
          </div>
        </FormGroup>
      </div>
      {obj?.careLabelDescriptionArr?.map((vl, ind) => {
        return (
          <>
            <div className="heading-icon-container mt-24 mb-24">
              <figure>
                <img src={getImageSrc(vl?.image)} alt="" />
              </figure>
              <button type="button" aria-label="Upload" className="btn pl-2 p-0 mr-16" onClick={() => handleImageUpload('care_user_instruction', '', ind)}>
                <i className="icon icon-Upload-1" />
              </button>
              <div className="common-input-control flex-fill mb-0">
                <p className="field-name"> {t('DPP.CONTROL.CARE_USER_LABEL.DESCRIPTION_TITLE')}</p>
                <input
                  type="text"
                  className="form-control"
                  value={vl?.title}
                  placeholder={t('DPP.CONTROL.CARE_USER_LABEL.ENTER_TITLE')}
                  onChange={(e) => handleChangeByPath(e.target.value, `careLabelDescriptionArr[${ind}].title`)}
                  maxLength="40"
                />
              </div>
            </div>
            <div className="d-flex justify-content-end align-items-end">
              <textarea
                name="comment"
                className="form-control custom-textarea f-16 text-medium"
                placeholder={t('DPP.CONTROL.CARE_USER_LABEL.ENTER_DESCRIPTION')}
                value={vl?.description}
                onChange={(e) => {
                  handleChangeByPath(e.target.value, `careLabelDescriptionArr[${ind}].description`);
                }}
              />{' '}
              {obj?.careLabelDescriptionArr?.length - 1 === ind ? (
                <div className="d-flex flex-column">
                  <button type="button" aria-label="Upload" className="btn btn-outline sm" onClick={() => addobj('careLabelDescriptionArr')}>
                    <i className="icon-Add-bold" />
                  </button>
                  {obj?.careLabelDescriptionArr?.length > 1 && (
                    <button
                      type="button"
                      aria-label="Upload"
                      className="btn btn-outline sm mt-1"
                      onClick={() => (obj?.careLabelDescriptionArr?.length > 1 ? removeObj(ind, 'careLabelDescriptionArr') : {})}
                    >
                      <i className="icon-Delete-bold" />
                    </button>
                  )}
                </div>
              ) : (
                <button
                  type="button"
                  aria-label="Upload"
                  className="btn btn-outline sm"
                  onClick={() => (obj?.careLabelDescriptionArr?.length > 1 ? removeObj(ind, 'careLabelDescriptionArr') : {})}
                >
                  <i className="icon-Delete-bold" />
                </button>
              )}
            </div>
          </>
        );
      })}
      <div className="d-flex">
        <AlignmentConfig
          obj={obj}
          handleAlignment={(e) => handleChangeByPath(e.target.value, 'otherConfiguration.descriptionAlignment')}
          dataName="descriptionAlignment"
        />
        <ColorConfig obj={obj} handleColor={(e) => handleChangeByPath(e.target.value, 'otherConfiguration.descriptionColour')} dataName="descriptionColour" />
        <BoldConfig obj={obj} handleBold={(e) => handleChangeByPath(e.target.checked, 'otherConfiguration.descriptionBold')} dataName="descriptionBold" />
      </div>
    </>
  );
});
CareUserInstructionSetting.displayName = 'CareUserInstructionSetting';
export default CareUserInstructionSetting;
